
import { Vue, Component, Prop,Watch } from "vue-property-decorator";
import { BaseVue } from "@newview/base-web";
@Component({
  name: "NVLoading",
  components: {
    
  },
})
export default class NVLoadingClass extends BaseVue {
  @Prop({ default: "加载中..." }) content!: any;
//#region 接口定义区

//#endregion 接口定义区


//#region 变量定义区


//#endregion 变量定义区


//#region 事件定义区
  mounted() {
  }
//#endregion 事件定义区


//#region 方法定义区

//#endregion 方法定义区
}
